module.exports = __webpack_public_path__ + "static/media/geng.390d1c21.jpg";